export function objectFilterTitle(object, filter) {
    return object.filter(item => item
        .title
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .match(new RegExp(filter
            .normalize("NFD").replace(/[\u0300-\u036f]/g, ""), "i")
        )
    );
}